// @flow

import { type Address } from '@tectonics/prs/address';
import { type IncomingPayment } from './types';

export function getAddress(incomingPayment: IncomingPayment): Address {
  return {
    country: incomingPayment['country'],
    zipcode: incomingPayment['zipcode'],
    state: incomingPayment['state'],
    city: incomingPayment['city'],
    street_name: incomingPayment['address'],
    street_number: incomingPayment['street_number'],
    street_complement: incomingPayment['street_complement'],
  };
}
